import 'angular:locale/data:pl';
import 'zone.js';(globalThis.$localize ??= {}).locale = "pl";
